import {stopImpersonatingUserOptions} from '@common/admin/users/users-queries';
import {useAuth} from '@common/auth/use-auth';
import {showHttpErrorToast} from '@common/http/errors/show-http-error-toast';
import {useMutation} from '@tanstack/react-query';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Trans} from '@ui/i18n/trans';

export function ImpersonationBanner() {
  const {user} = useAuth();
  const impersonator = getBootstrapData().impersonator;
  const stop = useMutation(stopImpersonatingUserOptions);

  if (!impersonator || !user) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 flex h-11 flex-nowrap items-center justify-between gap-3 border-b border-black/10 bg-primary px-4 text-sm text-white">
      <p className="min-w-0 truncate">
        <span className="font-medium">
          <Trans
            message="Viewing as :name"
            values={{name: user.name || user.email}}
          />
        </span>
        <span className="hidden text-white/80 sm:inline">
          {' — '}
          <Trans
            message="Return to :admin when you are done."
            values={{admin: impersonator.name}}
          />
        </span>
      </p>
      <button
        type="button"
        className="shrink-0 whitespace-nowrap rounded-md bg-white px-3 py-1.5 text-sm font-semibold text-neutral-900 shadow-sm"
        disabled={stop.isPending}
        onClick={() =>
          stop.mutate(undefined, {
            onError: err => showHttpErrorToast(err),
          })
        }
      >
        <Trans message="Back to admin" />
      </button>
    </div>
  );
}
